import { CARRIER_DATA_INITIAL_VALUES, CarrierData } from "./CarrierData";
import {
	CARRIER_ROLLSET_DATA_INITIAL_VALUES,
	CarrierRollsetData,
} from "./CarrierRollsetData";
import { Part, PART_INITIAL_VALUES } from "./Part";
import { ROLLSET_DATA_INITIAL_VALUES, RollsetData } from "./RollsetData";

export interface Arbor extends Part, CarrierRollsetData {
	Stands: string;
	StandsId: "";
	IsActive: boolean | null;
	// Universal Roll info
	UniversalRollPartId: number | null;
	UniversalRollName: string | null;
}

export const ARBOR_INITIAL_VALUES: Arbor = {
	...PART_INITIAL_VALUES,
	Stands: "",
	StandsId: "",
	IsActive: true,
	// Universal Roll info
	UniversalRollPartId: null,
	UniversalRollName: null,
	...CARRIER_ROLLSET_DATA_INITIAL_VALUES,
};
